/**
 * Sync step ids TestIntegration.Supports will run.
 * Form to eAdm (1034) and eHub overrides (1036) are not testable.
 *
 * Import steps whose company format is fetched only by the on-prem client
 * (Visma, Agresso, Aditro, Identum CSV, SD Worx, Personec, generic file,
 * security screening CSV) are testable in the engine but hidden here.
 */
import {ImportFormatId} from "../../../constants/ImportFormats";
import {SyncstepId} from "../../../constants/Syncstep";
import {ICompany} from "../../../index";

export const TESTABLE_SYNCSTEP_IDS: ReadonlySet<number> = new Set([
    1,
    4,
    13,
    1014,
    1015,
    1016,
    1018,
    1019,
    1020,
    1021,
    1022,
    1023,
    1024,
    1025,
    1026,
    1027,
    1028,
    1029,
    1030,
    1031,
    1032,
    1033,
    1035,
    1037,
    1038,
    1039,
    1040,
    1041,
    1042,
    1044,
    1045,
    1046,
    1047,
    1048,
    1049,
    1050,
    1052,
    1053,
    1061,
    1064,
    1065,
    1066,
    1069,
    1070,
    1071,
    1072,
    1073,
    1074,
    1075,
    1076,
    1077,
    1084,
    1085,
    1087,
    1088,
    1089,
    1093,
    1094,
    1095,
    1096,
    1097,
    1098,
    1099,
    1102,
    1120,
    1121,
    1122,
    1123,
    1124,
    1125,
    1126,
    1127,
    1103,
    1105,
    1106,
    1119,
]);

/** Formats the on-prem client uploads. ImportHRM does not fetch these in the cloud test run. */
export const ON_PREM_ONLY_IMPORT_FORMAT_IDS: ReadonlySet<number> = new Set([
    ImportFormatId.Visma,
    ImportFormatId.Visma_Hierachy,
    ImportFormatId.Agresso,
    ImportFormatId.Aditro,
    ImportFormatId.Identum_csv,
    ImportFormatId.SD_Worx,
    ImportFormatId.Personec_P_HR,
    ImportFormatId.Personec_P_HI,
    ImportFormatId.Generic_Import,
    ImportFormatId.Security_screening_CSV,
]);

type TImportFormatSlot = 'importformathr' | 'importformathi' | 'importformathr2' | 'importformathi2' | 'importformathr3' | 'importformathi3';

const IMPORT_FORMAT_SLOT_BY_SYNCSTEP: Partial<Record<number, TImportFormatSlot>> = {
    [SyncstepId.Import_HR]: 'importformathr',
    [SyncstepId.ImportHrFuture]: 'importformathr',
    [SyncstepId.ImportHrFuture2]: 'importformathr',
    [SyncstepId.ImportHR2]: 'importformathr2',
    [SyncstepId.ImportHR3]: 'importformathr3',
    [SyncstepId.Import_Hierachy]: 'importformathi',
    [SyncstepId.ImportHierachy2]: 'importformathi2',
    [SyncstepId.ImportHierachy3]: 'importformathi3',
};

export function isTestableSyncstep(syncstepId: number): boolean {
    return TESTABLE_SYNCSTEP_IDS.has(syncstepId);
}

export function isIntegrationTestStepVisible(syncstepId: number, company: ICompany | null): boolean {
    if (!isTestableSyncstep(syncstepId)) {
        return false;
    }
    const slot = IMPORT_FORMAT_SLOT_BY_SYNCSTEP[syncstepId];
    if (!slot) {
        return true;
    }
    if (!company) {
        return false;
    }
    const formatId = company[slot]?.id;
    return formatId == null || !ON_PREM_ONLY_IMPORT_FORMAT_IDS.has(formatId);
}
